import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { IconContext } from 'react-icons';
import classnames from 'classnames';
import CreditCardButton from './CreditCard.js';
import ApplePayButton from './ApplePay.js';
import PaypalButton from './Paypal.js';
import style from './style.scss';

const {
    colbyGiving: { modalContent },
} = window;

export default function ColbyGivingButtons() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const currentUrl = new URL(window.location);
        const paymentThankYou = currentUrl.searchParams.get('payment-thankyou');

        if (paymentThankYou === 'true') {
            setIsModalOpen(true);
        }
    }, []);

    function closeModal() {
        setIsModalOpen(false);
    }

    return (
        <IconContext.Provider value={{ style: { verticalAlign: 'middle' } }}>
            <div
                className={classnames({
                    'colby-giving-plugin-buttons': true,
                    [style.buttonsContainer]: true,
                })}
            >
                <CreditCardButton />
                <ApplePayButton />
                <PaypalButton />
                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    contentLabel="Thank you for your gift"
                    overlayClassName={style.modalOverlay}
                    className={style.modal}
                >
                    <div>
                        <div
                            className={classnames({
                                'colby-giving-plugin-buttons-modal-title': true,
                                [style.modalTitle]: true,
                            })}
                        >
                            Thank you for your gift to the Colby Fund
                        </div>
                    </div>
                    <div
                        className={classnames({
                            'colby-giving-plugin-buttons-modal-content': true,
                            [style.modalContent]: true,
                        })}
                    >
                        {modalContent}
                    </div>
                    <div
                        className={classnames({
                            'colby-giving-plugin-buttons-modal-close': true,
                            [style.modalClose]: true,
                        })}
                    >
                        <button
                            type="button"
                            className={classnames({
                                [style.modalCloseButton]: true,
                            })}
                            style={{ border: '1px solid #ccc' }}
                            onClick={closeModal}
                        >
                            close
                        </button>
                    </div>
                </Modal>
            </div>
        </IconContext.Provider>
    );
}
